/* BR Maritiem – verfadvies: gedeelde data, verfcalculator, verfwijzer, databladenfilter */
window.dwT=window.dwT||function(k,d){var o=window.DWT;return o&&o[k]!=null?o[k]:d};window.dwL=window.dwL||function(p){return (window.DWL||'')+p};
(function () {
  var DWV = window.DWV = window.DWV || {};
  var cache = {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function num(v) { if (v == null || v === '') return NaN; return parseFloat(String(v).replace(',', '.')); }
  function nf(v, d) { if (!isFinite(v)) return '–'; return v.toLocaleString('nl-NL', { minimumFractionDigits: d || 0, maximumFractionDigits: d == null ? 1 : d }); }
  function money(c) {
    if (window.DW && DW.fmt) return DW.fmt(c);
    return '€ ' + (c / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function has(arr, v) { return (arr || []).indexOf(v) > -1; }
  DWV.esc = esc; DWV.num = num; DWV.nf = nf;
  function rolT(g) { return dwT('rol_' + String(g).toLowerCase().replace(/[^a-z]+/g, '_').replace(/^_|_$/g, ''), g); }
  DWV.rolT = rolT;

  function norm(it) {
    it.r = it.r != null && it.r !== '' ? parseFloat(it.r) : null;
    it.lg = it.lg != null && it.lg !== '' ? parseInt(it.lg, 10) : null;
    it.z = it.z || []; it.o = it.o || []; it.s = it.s || []; it.vib = it.vib || [];
    return it;
  }

  /* Haalt alle verfproducten op (250 per pagina), met 10 minuten cache per sessie */
  DWV.load = function (handle) {
    handle = handle || 'verf-coatings';
    if (cache[handle]) return cache[handle];
    var key = 'dwv2_' + (window.DWL || '') + handle;
    try {
      var s = sessionStorage.getItem(key);
      if (s) { var o = JSON.parse(s); if (Date.now() - o.t < 600000) return (cache[handle] = Promise.resolve(o.d)); }
    } catch (e) {}
    function all(base) {
      function next(page, acc) {
        return fetch(base + handle + '?view=verfdata&page=' + page, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (t) {
            var j = JSON.parse(t); acc = acc.concat(j.items || []);
            return (j.pages && page < j.pages && page < 20) ? next(page + 1, acc) : acc;
          });
      }
      return next(1, []);
    }
    /* Ontwerp 50: de verfgegevens (rol, zones, ondergrond, segment) altijd uit de Nederlandse winkel, want daarop
       rekent de calculator. In het Engels alleen titel, korte tekst en link uit de Engelse versie. */
    var L = window.DWL || '';
    var src = all('/collections/');
    if (L) {
      src = Promise.all([src, all(L + '/collections/').catch(function () { return []; })]).then(function (r) {
        var en = {};
        r[1].forEach(function (x) { en[x.id] = x; });
        return r[0].map(function (x) {
          var e = en[x.id];
          if (e) { if (e.t) x.t = e.t; if (e.k) x.k = e.k; }
          if (x.u && x.u.charAt(0) === '/' && x.u.indexOf(L + '/') !== 0) x.u = L + x.u;
          return x;
        });
      });
    }
    cache[handle] = src.then(function (items) {
      items = items.map(norm);
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: items })); } catch (e) {}
      return items;
    });
    return cache[handle];
  };

  DWV.card = function (it) {
    var tags = '';
    if (it.c) tags += '<span class="vf-tag vf-tag--k">' + esc(it.c) + '</span>';
    if (it.r) tags += '<span class="vf-tag">' + nf(it.r) + ' m²/L</span>';
    if (it.v) tags += '<span class="vf-tag">' + esc(it.v) + '</span>';
    var price = it.p != null ? '<span class="vf-price" data-vf-price="' + it.p + '" data-pv="' + (it.pv ? 1 : 0) + '">' + (it.pv ? dwT('from', 'vanaf') + ' ' : '') + money(it.p) + '</span>' : '';
    return '<a class="vf-card" href="' + esc(it.u) + '">' +
      (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="vf-noimg" aria-hidden="true"></span>') +
      '<span><b>' + esc(it.t) + '</b>' + (it.k ? '<small>' + esc(it.k) + '</small>' : '') +
      '<span class="vf-tags">' + tags + '</span>' + price + '</span></a>';
  };
  function refreshPrices(root) {
    (root || document).querySelectorAll('[data-vf-price]').forEach(function (el) {
      el.textContent = (el.getAttribute('data-pv') === '1' ? dwT('from', 'vanaf') + ' ' : '') + money(parseInt(el.getAttribute('data-vf-price'), 10));
    });
  }
  document.addEventListener('dw:btw', function () { refreshPrices(); });

  /* ================= Verfcalculator ================= */
  DWV.calc = function (root) {
    var Z = {
      onder: { zone: 'Onderwaterschip', r: 9, l: 2 },
      boven: { zone: 'Bovenwaterschip', r: 11, l: 3 },
      dek: { zone: 'Dek', r: 10, l: 2 },
      opbouw: { zone: 'Bovenwaterschip', r: 11, l: 3 },
      eigen: { zone: null, r: 10, l: 2 }
    };
    var items = [], byId = {};
    function $(s) { return root.querySelector(s); }
    function val(n) { var el = root.querySelector('[name="' + n + '"]'); return el ? num(el.value) : NaN; }
    function boat() { var el = root.querySelector('[name="boot"]:checked'); return el ? el.value : 'motor'; }

    function areas() {
      var loa = val('loa'), lwl = val('lwl'), b = val('b'), d = val('d'), vb = val('vb');
      var ol = val('ol'), ob = val('ob'), oh = val('oh'), ra = val('ramen') || 0;
      if (!isFinite(lwl) && isFinite(loa)) lwl = loa * 0.85;
      var f = { motor: 1, lang: 0.75, kort: 0.5 }[boat()];
      var a = {};
      a.onder = boat() === 'vlak' ? lwl * (b + 2 * d) * 0.9 : lwl * (b + d) * f;
      a.boven = 2 * (loa + b) * vb;
      var foot = (isFinite(ol) && isFinite(ob)) ? ol * ob : 0;
      a.dek = 0.75 * loa * b - foot;
      a.opbouw = (isFinite(ol) && isFinite(ob) && isFinite(oh)) ? oh * (2 * ol + 2 * ob) + foot - ra : NaN;
      a.eigen = val('eigen_m2');
      Object.keys(a).forEach(function (k) { if (!isFinite(a[k]) || a[k] < 0) a[k] = NaN; });
      return a;
    }

    function fillSelects() {
      root.querySelectorAll('[data-vf-zone]').forEach(function (box) {
        var k = box.getAttribute('data-vf-zone'), zn = Z[k].zone, sel = box.querySelector('select[data-vf-prod]');
        if (!sel) return;
        var groups = {};
        items.forEach(function (it) {
          if (!it.r || it.rol === 'Verdunner' || it.rol === 'Reiniger & voorbereiding') return;
          if (zn && it.z.length && !has(it.z, zn)) return;
          (groups[it.rol || 'Overig'] = groups[it.rol || 'Overig'] || []).push(it);
        });
        var html = '<option value="">' + esc(dwT('own_yield', 'Eigen rendement invullen')) + '</option>';
        Object.keys(groups).sort().forEach(function (g) {
          html += '<optgroup label="' + esc(rolT(g)) + '">';
          groups[g].sort(function (x, y) { return x.t.localeCompare(y.t); }).forEach(function (it) {
            html += '<option value="' + it.id + '">' + esc(it.t) + ' – ' + nf(it.r) + ' m²/L</option>';
          });
          html += '</optgroup>';
        });
        sel.innerHTML = html;
      });
    }

    function pick(box, it) {
      var r = box.querySelector('[data-vf-r]'), l = box.querySelector('[data-vf-l]'), info = box.querySelector('[data-vf-pick]');
      if (it) {
        r.value = String(it.r).replace('.', ',');
        if (it.lg) l.value = it.lg;
        info.innerHTML = '<div class="vf-pick">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="52" height="52">' : '') +
          '<span><b>' + esc(it.t) + '</b><small>' + nf(it.r) + ' m²/L' + (it.ld ? ' ' + esc(dwT('at_dft', 'bij {n} µm droge laagdikte').replace('{n}', it.ld)) : '') + (it.lg ? ' · ' + esc(dwT('adv_coats', 'advies {n} lagen').replace('{n}', it.lg)) : '') + '</small><br><a href="' + esc(it.u) + '">' + esc(dwT('view_product', 'Bekijk product')) + '</a></span></div>';
      } else { info.innerHTML = ''; }
    }

    function render() {
      var a = areas(), loss = (val('verlies') || 0) / 100, total = 0, rows = '', any = false;
      root.querySelectorAll('[data-vf-zone]').forEach(function (box) {
        var k = box.getAttribute('data-vf-zone'), on = box.querySelector('[data-vf-on]').checked;
        box.querySelector('[data-vf-body]').hidden = !on;
        var m2 = a[k];
        box.querySelector('[data-vf-m2]').textContent = isFinite(m2) ? nf(m2) + ' m²' : dwT('enter_dims', 'vul de maten in');
        if (!on) return;
        var r = num(box.querySelector('[data-vf-r]').value), l = num(box.querySelector('[data-vf-l]').value) || 1;
        var lit = (isFinite(m2) && r > 0) ? m2 * l / r * (1 + loss) : NaN;
        box.querySelector('[data-vf-lit]').textContent = isFinite(lit) ? nf(lit) + ' ' + dwT('litre', 'liter') : '–';
        var name = box.getAttribute('data-vf-label');
        var sel = box.querySelector('select[data-vf-prod]'), it = sel && byId[sel.value];
        if (isFinite(lit)) { total += lit; any = true; }
        rows += '<div class="vf-res__row"><span><strong>' + esc(name) + '</strong><br><small class="dw-muted">' + (isFinite(m2) ? nf(m2) + ' m² × ' + l + ' ' + dwT('coats', 'lagen') + ' ÷ ' + nf(r) + ' m²/L' : dwT('dims_missing', 'maten ontbreken')) + (it ? '<br>' + esc(it.t) : '') + '</small></span><span><strong>' + (isFinite(lit) ? nf(lit) + ' L' : '–') + '</strong></span></div>';
      });
      $('[data-vf-rows]').innerHTML = rows || '<p class="dw-muted" style="margin:0">' + esc(dwT('pick_one', 'Kies links minimaal één onderdeel.')) + '</p>';
      $('[data-vf-total]').textContent = any ? nf(total) + ' ' + dwT('litre', 'liter') : '–';
      $('[data-vf-lossnote]').textContent = dwT('incl_loss', 'inclusief {n}% verlies').replace('{n}', nf(loss * 100, 0));
    }

    root.addEventListener('input', render);
    root.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-vf-prod]');
      if (sel) pick(sel.closest('[data-vf-zone]'), byId[sel.value]);
      render();
    });
    root.querySelectorAll('[data-vf-zone]').forEach(function (box) {
      var k = box.getAttribute('data-vf-zone');
      var r = box.querySelector('[data-vf-r]'), l = box.querySelector('[data-vf-l]');
      if (!r.value) r.value = Z[k].r; if (!l.value) l.value = Z[k].l;
    });
    render();

    DWV.load(root.getAttribute('data-collection')).then(function (list) {
      items = list; list.forEach(function (it) { byId[it.id] = it; });
      fillSelects();
      var pid = new URLSearchParams(location.search).get('p');
      if (pid && byId[pid]) {
        var it = byId[pid], k = has(it.z, 'Onderwaterschip') ? 'onder' : has(it.z, 'Bovenwaterschip') ? 'boven' : has(it.z, 'Dek') ? 'dek' : 'eigen';
        root.querySelectorAll('[data-vf-on]').forEach(function (c) { c.checked = false; });
        var box = root.querySelector('[data-vf-zone="' + k + '"]');
        box.querySelector('[data-vf-on]').checked = true;
        var sel = box.querySelector('select[data-vf-prod]'); sel.value = String(it.id);
        if (sel.value !== String(it.id)) { box = root.querySelector('[data-vf-zone="eigen"]'); box.querySelector('[data-vf-on]').checked = true; sel = box.querySelector('select[data-vf-prod]'); sel.value = String(it.id); }
        pick(box, byId[sel.value]);
        var note = $('[data-vf-prefill]'); if (note) { note.hidden = false; note.querySelector('b').textContent = it.t; }
      }
      render();
    }).catch(function () {
      root.querySelectorAll('select[data-vf-prod]').forEach(function (s) { s.innerHTML = '<option value="">' + esc(dwT('own_yield', 'Eigen rendement invullen')) + '</option>'; });
    });
  };

  /* ================= Verfwijzer ================= */
  var OND = { polyester: 'Polyester', staal: 'Staal', aluminium: 'Aluminium', hout: 'Hout', nonferro: 'Lood & non-ferro' };
  var SEG = { recreatie: 'Recreatievaart', beroeps: 'Beroepsvaart' };
  var ZN = {
    onder: ['Onderwaterschip'], boven: ['Bovenwaterschip'], dek: ['Dek'], opbouw: ['Bovenwaterschip', 'Interieur'],
    hout: ['Bovenwaterschip', 'Interieur'], schroef: ['Schroef & aandrijving'], ruim: ['Ruim & tanks', 'Staalconstructie']
  };
  var PRIMER_TXT = {
    polyester: 'Controleer polyester eerst op osmose (blaasjes, vocht). Bouw onder water een epoxyprimer op in meerdere lagen; die vormt de vochtwerende barrière.',
    staal: 'Staal stralen of tot blank metaal schuren en dezelfde dag nog een corrosiewerende primer aanbrengen. Onder water meestal meerdere lagen epoxy.',
    aluminium: 'Aluminium schuren, ontvetten en direct een geschikte primer aanbrengen; het oxideert snel weer. Een epoxyprimer isoleert het metaal.',
    hout: 'Kaal hout eerst verzadigen met een (verdunde) primer of epoxysealer, zodat er geen vocht in kan trekken. Daarna opbouwen.',
    nonferro: 'Brons, messing of lood opruwen en ontvetten en een primer gebruiken die geschikt is voor non-ferrometalen.'
  };
  function L(rol, title, text, opt, zones) { return { rol: rol, t: title, x: text, opt: !!opt, zones: zones }; }

  function buildSystem(a) {
    var s = [], z = a.zone, o = a.ond, sit = a.sit, zs = ZN[z];
    var prepKaal = 'Ondergrond schoon, droog en vetvrij maken. Ontvetten, schuren en stofvrij maken; bij metaal alle roest en losse delen verwijderen.';
    var prepOnd = 'Grondig reinigen en ontvetten, daarna licht opschuren tot een matte, vaste ondergrond. Kale plekken apart behandelen.';
    var notes = [];
    if (z === 'onder') {
      if (sit === 'onderhoud') {
        s.push(L('Reiniger & voorbereiding', 'Reinigen en opschuren', 'Aangroei met hogedruk verwijderen, loszittende antifouling wegschuren en kale plekken bijwerken met primer.', false, zs));
        s.push(L('Antifouling', 'Antifouling', 'Gebruik hetzelfde type antifouling als er al op zit (hard of zelfslijpend) en breng 2 lagen aan, extra op waterlijn, roer en voorsteven.', false, zs));
      } else if (sit === 'wissel') {
        s.push(L('Reiniger & voorbereiding', 'Reinigen en opschuren', prepOnd + ' Twijfel je over de oude laag? Verwijder hem dan volledig.', false, zs));
        s.push(L('Tiecoat', 'Isolerende hechtlaag', 'Een tiecoat of sealer scheidt de oude laag van het nieuwe systeem en zorgt voor hechting. Noodzakelijk bij onbekende of andersoortige antifouling.', false, zs));
        s.push(L('Antifouling', 'Nieuwe antifouling', 'Minimaal 2 lagen, binnen de overschildertijd van de hechtlaag.', false, zs));
      } else {
        s.push(L('Reiniger & voorbereiding', 'Voorbereiden', prepKaal, false, zs));
        s.push(L('Primer', 'Primer opbouwen', PRIMER_TXT[o] || PRIMER_TXT.polyester, false, zs));
        s.push(L('Plamuur & vuller', 'Plamuren', 'Putjes en beschadigingen vullen met een epoxyplamuur die geschikt is voor onder water. Daarna schuren en weer primeren.', true, zs));
        s.push(L('Tiecoat', 'Hechtlaag', 'Bij een volledig uitgeharde epoxyprimer is een tiecoat nodig voor de hechting van de antifouling. Volg het datablad: soms kan de antifouling ook "nat-in-kleverig" op de laatste primerlaag.', true, zs));
        s.push(L('Antifouling', 'Antifouling', 'Minimaal 2 lagen. Hard voor snelle boten en droogvallen, zelfslijpend voor zeilboten en langzaam varende schepen.', false, zs));
      }
      if (o === 'aluminium') notes.push(['warn', 'Aluminium: gebruik nooit een antifouling met koper of koperoxide. Kies een kopervrije antifouling die uitdrukkelijk geschikt is voor aluminium.']);
    } else if (z === 'boven' || z === 'opbouw' || z === 'dek') {
      if (sit === 'onderhoud') {
        s.push(L('Reiniger & voorbereiding', 'Reinigen en opschuren', prepOnd, false, zs));
        s.push(L('Grondverf', 'Grondverf op kale plekken', 'Kale of geplamuurde plekken eerst voorzien van primer en grondverf, zodat de aflak overal even mooi uitvloeit.', true, zs));
        s.push(L('Aflak', 'Aflak', 'Twee lagen aflak, met tussendoor licht schuren. Een 1K lak kan over een goede 2K laag; andersom niet.', false, zs));
      } else if (sit === 'wissel') {
        s.push(L('Reiniger & voorbereiding', 'Reinigen en opschuren', prepOnd, false, zs));
        s.push(L('Primer', 'Isolerende primer', 'Wil je een 2K lak over een bestaande 1K laag? Verwijder de oude laag of isoleer hem met een geschikte primer; 2K-oplosmiddelen kunnen een 1K laag doen opbollen.', false, zs));
        s.push(L('Grondverf', 'Grondverf', 'Een of twee lagen grondverf/undercoat voor dekking en een egale ondergrond.', false, zs));
        s.push(L('Aflak', 'Aflak', 'Twee à drie lagen aflak, met tussendoor licht schuren.', false, zs));
      } else {
        s.push(L('Reiniger & voorbereiding', 'Voorbereiden', prepKaal, false, zs));
        s.push(L('Primer', 'Primer', PRIMER_TXT[o] || PRIMER_TXT.polyester, false, zs));
        s.push(L('Plamuur & vuller', 'Plamuren', 'Oneffenheden wegwerken met plamuur, daarna schuren en opnieuw primeren.', true, zs));
        s.push(L('Grondverf', 'Grondverf', 'Een of twee lagen grondverf/undercoat. Die geeft dekking en vult fijne schuurkrassen.', false, zs));
        s.push(L('Aflak', 'Aflak', 'Twee à drie lagen aflak, met tussendoor licht schuren voor een strak resultaat.', false, zs));
      }
      if (z === 'dek') {
        s.push(L('Antislip', 'Antislip', 'Meng antislipkorrels door de laatste laag of gebruik een antislip-dekverf op de looproutes.', true, ['Dek']));
        if (o === 'hout') notes.push(['info', 'Teakdek? Teak schilder je niet: reinig het, herstel de kleur en behandel het met teakolie. Kies hiervoor de producten bij "Teakonderhoud" hieronder.', 'Teakonderhoud']);
      }
    } else if (z === 'hout') {
      s.push(L('Reiniger & voorbereiding', 'Schuren en ontvetten', sit === 'kaal' ? 'Kaal hout schuren (korrel 120 → 180/240), ontvetten en stofvrij maken. Olieachtige houtsoorten zoals teak eerst ontvetten.' : 'Licht opschuren tot de oude lak mat is, stofvrij maken. Loszittende of vergrijsde plekken tot op het hout terugschuren.', false, zs));
      s.push(L('Blanke lak', 'Blanke lak opbouwen', sit === 'kaal' ? 'Eerste laag 10–20% verdund laten intrekken, daarna 5 tot 8 lagen opbouwen voor buitenwerk, met tussendoor licht schuren.' : 'Twee tot drie onderhoudslagen, met tussendoor licht schuren.', false, zs));
    } else if (z === 'schroef') {
      s.push(L('Reiniger & voorbereiding', 'Voorbereiden', 'Schroef, as of staartstuk tot blank metaal opruwen en grondig ontvetten.', false, zs));
      s.push(L('Primer', 'Primer voor metaal', 'Een primer die hecht op brons, aluminium of rvs. Dun en egaal aanbrengen.', false, zs));
      s.push(L('Antifouling', 'Antifouling voor schroef en aandrijving', 'Een speciale schroef-antifouling of fouling release. Bij aluminium aandrijvingen altijd kopervrij.', false, zs));
    } else if (z === 'ruim') {
      s.push(L('Reiniger & voorbereiding', 'Voorbereiden', 'Stralen (bij voorkeur Sa 2½) of mechanisch reinigen, stofvrij en zoutvrij maken.', false, zs));
      s.push(L('Primer', 'Corrosiewerende primer', 'Zinkrijke of epoxy primer direct na het stralen. Voor ruimen en ballasttanks een slijtvaste epoxy in hoge laagdikte.', false, zs));
      s.push(L('Primer', 'Tussenlaag', 'Extra epoxylaag of mastic voor laagdikte en slijtvastheid.', true, zs));
      s.push(L('Aflak', 'Afwerking', 'Polyurethaan of alkyd aflak waar kleur- en glansbehoud belangrijk is.', true, zs));
    }
    return { layers: s, notes: notes };
  }

  function rank(items, layer, a) {
    var ondN = OND[a.ond], segN = SEG[a.seg], comp = a.comp && a.comp !== 'geen' ? a.comp : null;
    var base = items.filter(function (it) {
      if (it.rol !== layer.rol) return false;
      if (layer.zones && layer.zones.length && it.z.length && !layer.zones.some(function (z) { return has(it.z, z); })) return false;
      return true;
    });
    function ondOk(it) { return !ondN || !it.o.length || has(it.o, ondN) || (a.sit !== 'kaal' && has(it.o, 'Bestaande verflaag')); }
    function segOk(it) { return !segN || !it.s.length || has(it.s, segN); }
    var list = base.filter(function (it) { return ondOk(it) && segOk(it); }), loose = false;
    if (!list.length) { list = base.filter(ondOk); loose = list.length > 0; }
    if (!list.length) { list = base; loose = list.length > 0; }
    list.forEach(function (it) {
      var sc = 0;
      if (ondN && has(it.o, ondN)) sc += 3;
      if (segN && has(it.s, segN)) sc += 2;
      if (comp && it.c === comp) sc += 2;
      if (it.a) sc += 1;
      it._sc = sc;
    });
    list.sort(function (x, y) { return (y._sc - x._sc) || x.t.localeCompare(y.t); });
    return { list: list, loose: loose };
  }

  DWV.wizard = function (root) {
    var items = null, out = root.querySelector('[data-vf-out]');
    function ans() {
      var a = {};
      ['zone', 'ond', 'sit', 'seg', 'comp'].forEach(function (n) { var el = root.querySelector('[name="vf_' + n + '"]:checked'); a[n] = el ? el.value : null; });
      return a;
    }
    function render() {
      var a = ans();
      var fixedOnd = a.zone === 'hout';
      var ondQ = root.querySelector('[data-vf-q="ond"]');
      if (ondQ) { ondQ.hidden = fixedOnd; if (fixedOnd) a.ond = 'hout'; }
      if (!a.zone || !a.ond || !a.sit) {
        out.innerHTML = '<div class="dw-empty" style="text-align:center">' + (root.querySelector('[data-vf-illu]') ? root.querySelector('[data-vf-illu]').innerHTML : '') + 'Beantwoord de vragen hierboven. Je ziet dan meteen welke lagen je nodig hebt en welke producten passen.</div>';
        return;
      }
      var sys = buildSystem(a), html = '';
      sys.notes.forEach(function (n) { html += '<div class="vf-alert' + (n[0] === 'warn' ? ' vf-alert--warn' : '') + '">' + esc(n[1]) + '</div>'; });
      if (a.comp === '2K' && a.sit === 'onderhoud') html += '<div class="vf-alert">2K over een bestaande 1K laag kan problemen geven. Weet je niet wat er op zit? Kies dan "Ander systeem over bestaande verf".</div>';
      html += '<div class="vf-system">';
      var n = 0;
      sys.layers.forEach(function (ly, i) {
        n++;
        var block = '';
        if (items) {
          var r = rank(items, ly, a), list = r.list;
          if (list.length) {
            block += '<div class="vf-cards" data-vf-list>' + list.slice(0, 4).map(DWV.card).join('') + '</div>';
            if (list.length > 4) block += '<div class="vf-cards" hidden data-vf-rest>' + list.slice(4).map(DWV.card).join('') + '</div><button type="button" class="vf-more" data-vf-more>Toon alle ' + list.length + ' producten</button>';
            if (r.loose) block += '<p class="vf-hint">Geen exacte match op je keuzes; dit zijn de producten die het dichtst in de buurt komen. Controleer het datablad.</p>';
          } else if (ly.rol !== 'Reiniger & voorbereiding') {
            block += '<p class="vf-hint">Hiervoor hebben we nog geen passend product online. Vraag ons gerust om advies.</p>';
          }
        } else block += '<p class="vf-hint">Producten laden…</p>';
        html += '<div class="vf-layer"><span class="vf-layer__n' + (ly.opt ? ' is-opt' : '') + '">' + n + '</span><div><h3>' + esc(ly.t) + (ly.opt ? ' <span class="vf-tag">optioneel</span>' : '') + '</h3><p>' + esc(ly.x) + '</p>' + block + '</div></div>';
      });
      html += '</div>';
      sys.notes.forEach(function (nn) {
        if (nn[2] && items) {
          var r = rank(items, { rol: nn[2], zones: null }, a);
          if (r.list.length) html += '<h3 style="margin-top:8px">' + esc(nn[2]) + '</h3><div class="vf-cards">' + r.list.slice(0, 6).map(DWV.card).join('') + '</div>';
        }
      });
      html += '<div class="vf-alert" style="margin-top:18px">Verdunnen en gereedschap reinigen: gebruik de verdunner die in het datablad van het product staat. Combineer bij voorkeur producten uit één systeem en houd je aan de overschildertijden.</div>';
      html += '<div class="vf-actions"><a class="dw-btn dw-btn--primary" href="' + esc(root.getAttribute('data-calc-url') || '/pages/verfcalculator') + '">Bereken hoeveel verf je nodig hebt</a><a class="dw-btn dw-btn--line" href="' + esc(root.getAttribute('data-docs-url') || '/pages/databladen') + '">Databladen bekijken</a><a class="dw-btn dw-btn--soft" href="/pages/contact">Advies vragen</a></div>';
      out.innerHTML = html;
      refreshPrices(out);
    }
    root.addEventListener('change', render);
    out.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vf-more]'); if (!b) return;
      var rest = b.previousElementSibling; rest.hidden = false; b.remove();
    });
    render();
    DWV.load(root.getAttribute('data-collection')).then(function (list) { items = list.filter(function (it) { return it.rol; }); render(); })
      .catch(function () { items = []; render(); });
  };

  /* ================= Databladen-filter ================= */
  DWV.docs = function (root) {
    var q = root.querySelector('[data-vf-q]'), vSel = root.querySelector('[data-vf-vendor]'), rSel = root.querySelector('[data-vf-rol]'),
      rows = [].slice.call(root.querySelectorAll('[data-vf-row]')), cnt = root.querySelector('[data-vf-count]'), none = root.querySelector('[data-vf-none]');
    function run() {
      var t = (q.value || '').toLowerCase().trim(), v = vSel.value, r = rSel.value, n = 0;
      rows.forEach(function (tr) {
        var ok = (!t || tr.getAttribute('data-s').indexOf(t) > -1) && (!v || tr.getAttribute('data-v') === v) && (!r || tr.getAttribute('data-r') === r);
        tr.hidden = !ok; if (ok) n++;
      });
      cnt.textContent = n + ' ' + (n === 1 ? dwT('product_one', 'product') : dwT('product_many', 'producten'));
      none.hidden = n > 0;
    }
    [q, vSel, rSel].forEach(function (el) { el.addEventListener('input', run); el.addEventListener('change', run); });
    var p = new URLSearchParams(location.search);
    if (p.get('merk')) vSel.value = p.get('merk');
    if (p.get('q')) q.value = p.get('q');
    run();
  };

  function boot() {
    document.querySelectorAll('[data-vf-calc]').forEach(DWV.calc);
    document.querySelectorAll('[data-vf-wizard]').forEach(DWV.wizard);
    document.querySelectorAll('[data-vf-docs]').forEach(DWV.docs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
